import React from 'react';

import { margin, useClassnames } from '@lumapps/classnames';
import { get } from '@lumapps/constants';
import { NavigationSkeleton } from '@lumapps/lumx-navigation/components/NavigationSkeleton';
import { ViewMode } from '@lumapps/lumx-navigation/constants';
import { SkeletonRectangle, Theme, FlexBox } from '@lumapps/lumx/react';

const CLASSNAME = 'space-header';

const { isMobileAppWebView } = get();

export const SpaceHeaderSkeleton: React.FC = () => {
    const { block, element } = useClassnames(CLASSNAME);

    if (isMobileAppWebView) {
        return null;
    }

    return (
        <FlexBox orientation="vertical" gap="big" as="header" className={block([margin('bottom', 'big')])}>
            <SkeletonRectangle className={element('banner')} theme={Theme.light} />
            <NavigationSkeleton theme={Theme.light} viewMode={ViewMode.horizontal} />
        </FlexBox>
    );
};
